export const AddIcon = () => {
    return (
        <svg
            className="addIcon"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 6.69421V13.2885"
                stroke="#546EDB"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3003 9.99094H6.69971"
                stroke="#546EDB"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.2171 1H5.78286C2.84286 1 1 3.08088 1 6.02664V13.9734C1 16.9191 2.83429 19 5.78286 19H14.2171C17.1657 19 19 16.9191 19 13.9734V6.02664C19 3.08088 17.1657 1 14.2171 1Z"
                stroke="#546EDB"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
